(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
  }

  function text(el) { return (el && (el.textContent || '').replace(/\s+/g, ' ').trim()) || ''; }
  function status(message) {
    var region = document.getElementById('roam-a11y-status');
    if (region && message) region.textContent = message;
  }

  function ensureUsefulLabel(el, fallback) {
    if (!el || text(el) || el.getAttribute('aria-label') || el.getAttribute('aria-labelledby') || el.getAttribute('title')) return;
    el.setAttribute('aria-label', fallback);
  }

  function patchPageFlyAndContentImages() {
    document.querySelectorAll('img:not([alt])').forEach(function (img) {
      var heading = img.closest('section, article, [data-pf-type="Section"], .pf-c, .product-card')?.querySelector('h1,h2,h3,h4,h5,h6,[data-pf-type="Heading"]');
      var label = text(heading) || img.getAttribute('data-alt') || img.getAttribute('title') || 'ROAM Adventure Co. image';
      img.setAttribute('alt', label);
    });
  }

  function patchEmptyInteractiveLabels() {
    document.querySelectorAll('a[href]').forEach(function (a) {
      if (text(a) || a.getAttribute('aria-label') || a.getAttribute('aria-labelledby')) return;
      var href = a.getAttribute('href') || '';
      var label = 'Open link';
      if (href.indexOf('/cart') >= 0) label = 'View cart';
      else if (href.indexOf('/account') >= 0) label = 'View account';
      else if (href === '/' || href.indexOf('/?') === 0) label = 'Go to homepage';
      else if (a.querySelector('img[alt]:not([alt=""])')) label = a.querySelector('img[alt]:not([alt=""])').getAttribute('alt');
      a.setAttribute('aria-label', label);
    });
    document.querySelectorAll('button').forEach(function (button) { ensureUsefulLabel(button, 'Button'); });
  }

  function patchHiddenContentFocus() {
    document.querySelectorAll('[x-cloak], [x-show]').forEach(function (el) {
      if (el.offsetParent === null && !el.hasAttribute('aria-hidden')) el.setAttribute('aria-hidden', 'true');
    });
  }

  function patchForms() {
    document.querySelectorAll('form').forEach(function (form, index) {
      if (!form.id) form.id = 'roam-form-' + (index + 1);
      form.querySelectorAll('.errors, [class*="error"], [id*="error"]').forEach(function (err) {
        err.setAttribute('role', 'alert');
        err.setAttribute('aria-live', 'assertive');
      });
      form.addEventListener('submit', function () { status('Submitting form.'); }, { passive: true });
    });
  }

  function patchTables() {
    document.querySelectorAll('table.product__specs-table:not([aria-label])').forEach(function (table) {
      table.setAttribute('aria-label', 'Product specifications');
    });
  }

  function patchCurrentLocation() {
    var path = window.location.pathname.replace(/\/$/, '');
    document.querySelectorAll('a[href]').forEach(function (a) {
      var href = a.getAttribute('href');
      if (!href || href.indexOf('#') === 0) return;
      var test = href.replace(window.location.origin, '').replace(/\/$/, '');
      if (test === path) a.setAttribute('aria-current', 'page');
    });
  }

  function patchMotion() {
    if (!window.matchMedia || !window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('[autoplay], video').forEach(function (media) {
      media.removeAttribute('autoplay');
      if (typeof media.pause === 'function') media.pause();
    });
  }

  function patchCartAnnouncements() {
    window.addEventListener('cart-updated', function (event) {
      var qty = event && event.detail && event.detail.quantity;
      if (typeof qty !== 'undefined') status('Cart updated. ' + qty + ' item' + (qty == 1 ? '' : 's') + ' in cart.');
      else status('Cart updated.');
    });
  }

  ready(function () {
    patchPageFlyAndContentImages();
    patchEmptyInteractiveLabels();
    patchHiddenContentFocus();
    patchForms();
    patchTables();
    patchCurrentLocation();
    patchMotion();
    patchCartAnnouncements();
  });
})();
